import React from "react";
import { Helmet } from "react-helmet";
import { usePartner } from "../../hooks/usePartner";

export default function Head() {
  const { partnerName } = usePartner();

  return (
    <>
      <Helmet>
        <title>{partnerName ? `Sou Stix - ${partnerName}` : "Sou Stix"}</title>
      </Helmet>
    </>
  );
}
